import { useState, useCallback } from 'react';
import { SpellCategory, SpecialTag } from '../types';

export interface PopoverItem {
  id?: string;
  itemType?: 'spell' | 'weapon';
  name: string;
  description: string | null;
  specialTags: SpecialTag[];
  damageModifier?: number | null;
  categories?: SpellCategory[];
}

export interface PopoverState {
  anchor: HTMLElement;
  id?: string;
  itemType?: 'spell' | 'weapon';
  name: string;
  description: string | null;
  tags: SpecialTag[];
  damageModifier?: number | null;
  categories?: SpellCategory[];
  modifiers?: string | null;
}

/**
 * Custom hook for managing item popover state and handlers
 * Used across multiple tabs to display weapon/spell/item details
 */
export const useItemPopover = () => {
  const [popover, setPopover] = useState<PopoverState | null>(null);

  const handleItemClick = useCallback((
    e: React.MouseEvent<HTMLElement>,
    item: PopoverItem
  ) => {
    setPopover({
      anchor: e.currentTarget,
      id: item.id,
      itemType: item.itemType,
      name: item.name,
      description: item.description,
      tags: item.specialTags,
      damageModifier: item.damageModifier,
      categories: item.categories,
    });
  }, []);

  const closePopover = useCallback(() => {
    setPopover(null);
  }, []);

  return {
    popover,
    setPopover,
    handleItemClick,
    closePopover,
  };
};
